<template>
  <el-form-item
    :label="titlize(label)"
    :rules="metaData.is_required ? requiredField() : []"
  >
    <el-radio-group class="radio-collection" v-model="selectedOption">
      <el-radio
        class="rdo-label"
        v-for="(option, i) in options"
        :key="i"
        :label="option"
        :disabled="preview"
        >{{ titlize(option) }}</el-radio
      >
    </el-radio-group>

    <div class="el-form-item__error">
      {{ errMsg }}
    </div>
  </el-form-item>
</template>

<script>
import { titleCase } from "@/lib/utils";

export default {
  name: "Radio",
  props: {
    label: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    value: {
      type: String,
      default: ""
    },
    metaData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    colors: {
      type: Object,
      default() {
        return {};
      }
    },
    parentForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    formIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      input: "",
      selectedOption: "",
      errMsg: ""
    };
  },
  inject: ["preview"],

  computed: {
    setValue: {
      get() {
        return this.selectedOption;
      },
      set(value) {
        this.$emit("update:value", value);
      }
    },
    preview() {
      return this.preview;
    }
  },

  methods: {
    titlize(option) {
      return titleCase(option);
    },

    validateInput() {
      if (!this.metaData.is_required && !this.selectedOption) {
        return;
      }

      if (this.metaData.is_required && !this.selectedOption) {
        this.errMsg = `${this.titlize(this.label)} is required`;
        this.$emit("isValid", false);
      } else {
        this.errMsg = "";
      }
    }
  },

  watch: {
    selectedOption(val) {
      this.validateInput();
      this.setValue = val;
      setTimeout(() => {
        const radioButtons = document.querySelectorAll(
          ".radio-collection .el-radio .el-radio__inner"
        );
        radioButtons.forEach(button => {
          button.parentElement.nextSibling.style.color = "rgba(0,0,0,.86)";
          button.style.background = "none";
          button.style.borderColor = "#dcdfe6";
        });
      });

      setTimeout(() => {
        const radioButtonsChecked = document.querySelectorAll(
          ".radio-collection .el-radio__input.is-checked .el-radio__inner"
        );
        radioButtonsChecked.forEach(button => {
          button.parentElement.nextSibling.style.color = this.colors.secondary;
          button.style.background = this.colors.secondary;
          button.style.borderColor = this.colors.secondary;
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.radio-collection {
  clear: both;
  display: block;
  width: 100%;
}
.rdo-label {
  width: 45%;
  margin: 0 10px 10px 0;
  display: flex;
  float: left;
}

@media (max-width: 1024px) {
  .rdo-label {
    width: 48% !important;
    margin-right: 1%;
  }
}

@media (max-width: 768px) {
  .rdo-label {
    width: 48% !important;
    margin-right: 1%;
  }
}

@media (max-width: 600px) {
  .rdo-label {
    width: 98% !important;
    margin-right: 1%;
  }
}
</style>
